import deserialize from './deserialize';
import serialize from './serialize';

export const FieldSerializer = {
    deserialize,
    serialize,
};

export default FieldSerializer;
